var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeAvaliadores(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 61,
    viewBox: "0 0 45 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6866_32730)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9894 38.7129C11.5314 38.7129 3.0437 42.9567 3.0437 48.1857C3.0437 52.4296 8.61374 56.0103 16.3057 57.2228V63.3423L23.884 55.764L16.3057 48.1857V53.3579C10.3378 52.297 6.83284 49.7582 6.83284 48.1857C6.83284 46.1775 12.5923 42.502 21.9894 42.502C31.3865 42.502 37.146 46.1775 37.146 48.1857C37.146 49.5688 34.3799 51.7665 29.5677 52.979V56.8629C36.2555 55.4041 40.9351 52.0696 40.9351 48.1857C40.9351 42.9567 32.4474 38.7129 21.9894 38.7129Z",
    fill: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2361 -0.0439453C12.2741 -0.0439453 4.21704 8.01313 4.21704 17.9751C4.21704 31.4893 22.2361 51.4389 22.2361 51.4389C22.2361 51.4389 40.2551 31.4893 40.2551 17.9751C40.2551 8.01313 32.198 -0.0439453 22.2361 -0.0439453ZM22.2361 24.4108C18.6838 24.4108 15.8008 21.5277 15.8008 17.9754C15.8008 14.4231 18.6838 11.54 22.2361 11.54C25.7885 11.54 28.6715 14.4231 28.6715 17.9754C28.6715 21.5277 25.7885 24.4108 22.2361 24.4108Z",
    fill: "#606060"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6866_32730"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 60.5769,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeAvaliadores);
export default __webpack_public_path__ + "static/media/IconeAvaliadores.a99785614015bee6dfd3c562de3707ea.svg";
export { ForwardRef as ReactComponent };